if (!customElements.get('diy-market-selector')) {
  customElements.define('diy-market-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.querySelector('details');
      this.querySelectorAll('[data-market-flag]').forEach(element => {
        const code = element.dataset.marketFlag;
        if (/^[A-Z]{2}$/.test(code)) element.textContent = [...code].map(letter => String.fromCodePoint(127397 + letter.charCodeAt(0))).join('');
      });
      this.onOutside = event => { if (!this.contains(event.target)) this.details.open = false; };
      document.addEventListener('click', this.onOutside);
      this.addEventListener('keyup', event => {
        if (event.key !== 'Escape' || !this.details.open) return;
        event.stopPropagation();
        this.details.open = false;
        this.querySelector('summary').focus();
      });
      this.querySelector('form').addEventListener('submit', event => {
        const form = event.currentTarget;
        const data = new FormData(form);
        const destination = new URL(form.querySelector('[name="return_to"]')?.value || location.pathname, location.origin);
        destination.searchParams.delete('variant');
        const returnTo = form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = destination.pathname + destination.search;
        if (['127.0.0.1', 'localhost'].includes(location.hostname) && data.get('country_code') === this.dataset.country) {
          const alternate = [...document.querySelectorAll('link[rel="alternate"][hreflang]')].find(link => link.hreflang === data.get('language_code'));
          if (alternate) {
            event.preventDefault();
            const url = new URL(alternate.href);
            url.searchParams.delete('variant');
            location.assign(location.origin + url.pathname + url.search);
          }
        }
      });
    }
    disconnectedCallback() { document.removeEventListener('click', this.onOutside); }
  });
}
